export class JuchuData {
  /*
   * 注文番号
   */
  jyuNo: string = '';

  /**
   * 注文日時
   */
  jyuDt: string = '';

  /**
   * 得意先CD
   */
  tokCd: string = '';

  /**
   * 得意先営業所CD
   */
  tokCd2: string = '';

  /**
   * 得意先名
   */
  tokNm: string = '';

  /**
   * 拠点名
   */
  ktnNm: string = '';

  /**
   * 電話番号
   */
  telNo: string = '';

  /**
   * KS社員氏名
   */
  tanNm: string = '';

  /**
   * SEQ
   */
  nouCd: number | undefined;

  /**
   * 納入先名
   */
  nouNm: string = '';

  /**
   * 納入先_県CD
   */
  adrKenCd: string = '';

  /**
   * 納入先_市区町村CD
   */
  adrSiCd: string = '';

  /**
   * 県
   */
  kenNm: string = '';

  /**
   * 市区町村
   */
  siNm: string = '';

  /**
   * 住所１
   */
  adrTyo: string = '';

  /**
   * 住所２
   */
  adrBan: string = '';

  /**
   * 得意先注文NO
   */
  ttyumonNo: string = '';

  /**
   * 工事管理番号
   */
  kojiNo: string = '';

  /**
   * 工事名称
   */
  kojiNm: string = '';

  /**
   * 希望納期
   */
  kiboDt: string = '';

  /**
   * 希望納期_AM/PM
   */
  kiboKbn: string = '';

  /**
   * ユーザー_得意先CD
   */
  userCd: string = '';

  /**
   * ユーザー_得意先営業所CD
   */
  userCd2: string = '';

  /**
   * 得意先名
   */
  userNm: string = '';

  /**
   * 特価案件区分
   */
  tokkaFlg: string = '';

  /**
   * チャーター希望
   */
  chartFlg: string = '';

  /**
   * 連絡メモ
   */
  renMemo: string = '';

  /**
   * 回答メモ
   */
  kaitoMemo: string = '';

  /**
   * 送り状メモ
   */
  okuriMemo: string = '';

  /**
   * 配送メモ
   */
  haisoMemo: string = '';

  /**
   * 自社区分
   */
  jishaKbn: string = '';

  /**
   * 処理選択
   */
  shoriSentaku: string = '';

  /**
   * カンパニーCD
   */
  companyCd: string = '';

  /**
   * アカウントID
   */
  accountId: string = '';

  /**
   * 納入先電話番号
   */
  nonyuTel: string = '';

  /**
   * 納入先郵便番号
   */
  nonyuYubin: string = '';

  /**
   * 受注データ.納入先名称
   */
  juchuNouNm: string = '';

  /**
   * 更新日
   */
  updDt: string = '';

  static FIELD_KEY_NAME = {
    jyuNo: 'jyuNo',

    jyuDt: 'jyuDt',

    tokCd: 'tokCd',

    tokCd2: 'tokCd2',

    tokNm: 'tokNm',

    ktnNm: 'ktnNm',

    telNo: 'telNo',

    tanNm: 'tanNm',

    nouCd: 'nouCd',

    nouNm: 'nouNm',

    adrKenCd: 'adrKenCd',

    adrSiCd: 'adrSiCd',

    kenNm: 'kenNm',

    siNm: 'siNm',

    adrTyo: 'adrTyo',

    adrBan: 'adrBan',

    ttyumonNo: 'ttyumonNo',

    kojiNo: 'kojiNo',

    kojiNm: 'kojiNm',

    kiboDt: 'kiboDt',

    kiboKbn: 'kiboKbn',

    userCd: 'userCd',

    userCd2: 'userCd2',

    userNm: 'userNm',

    tokkaFlg: 'tokkaFlg',

    chartFlg: 'chartFlg',

    renMemo: 'renMemo',

    kaitoMemo: 'kaitoMemo',

    okuriMemo: 'okuriMemo',

    haisoMemo: 'haisoMemo',

    jishaKbn: 'jishaKbn',

    shoriSentaku: 'shoriSentaku',

    companyCd: 'companyCd',

    accountId: 'accountId',

    updDt: 'updDt',
  };
}
